import {
  selectPOSstationID,
  selectPOSSelectedStation,
} from '@modules/point-of-sale/slice/pos-selector';
import { Card, Chip, IconButton, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import ServoLogo from '@assets/servo-logo.svg';
import ServoTextLogo from '@assets/servo-text-logo.svg';
import { getColor } from '@assets/theme';
import Image from '@components/ui/image';
import { StationSelector } from '@components/ui/pos-station-selector';
import { ChevronRight, Close } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useGetUserPrivilegeQuery } from '@api/users-management/user-mangement.api.rtk';
import useAppContext from '@hooks/useAppContext';
import { useAppDispatch, useAppSelector } from '@store/index';
import { setPOSInitialSetupActive } from '@modules/point-of-sale/slice/pos-stations.slice';

interface IStationSelectorProps {
  onClose: () => void;
  moduleCode?: string;
  setInitialSetupModule?: (moduleCode: string) => void;
}

const PosISSelection = ({
  onClose,
  setInitialSetupModule,
}: IStationSelectorProps) => {
  const { startLoadingStatus, stopLoadingStatus } = useAppContext();
  const dispatch = useAppDispatch();
  const hasStation = useAppSelector(selectPOSSelectedStation);
  const stationID = useAppSelector(selectPOSstationID);

  const constraintsRef = useRef(null);
  const { bgColor, white, primary } = getColor();

  const handleProceed = () => {
    if (hasStation) {
      dispatch(setPOSInitialSetupActive(true));
      setInitialSetupModule?.('POS');
      onClose();
      //   navigate(moduleCode);
    }
  };

  const { isLoading, isFetching } = useGetUserPrivilegeQuery(
    { roleID: '', refetch: stationID },
    { refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    isLoading || isFetching
      ? startLoadingStatus('Loading Stations...')
      : stopLoadingStatus?.();
  }, [isLoading, isFetching]);

  return (
    <Stack
      component={motion.div}
      ref={constraintsRef}
      sx={{
        flex: 1,
        minHeight: 0,
        bgcolor: bgColor,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card
        sx={{
          width: '497px',
          bgcolor: white,
          padding: '32px',
          maxWidth: { xs: '90vw', sm: '550px' },
          zIndex: 99,
          overflowY: 'auto',
          position: 'relative',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          size='small'
          sx={{ position: 'absolute', top: 12, right: 12 }}
        >
          <Close fontSize='small' />
        </IconButton>
        {/* Header */}
        <Stack
          direction='row'
          sx={{
            paddingBottom: '24px',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
          }}
        >
          <Image img={ServoLogo} width={40} height={32} />
          <Image img={ServoTextLogo} width={131} height={21} />
          <Chip
            label='POS'
            sx={{
              cursor: 'default',
              bgcolor: primary,
              color: '#FFF',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Poppins',
              px: 0.5,
            }}
          />
        </Stack>
        {/* Station Selection */}
        <Stack gap={2}>
          <StationSelector isDashboard isInitialSetup />
          <Button
            variant='contained'
            size='large'
            endIcon={<ChevronRight />}
            sx={{ width: '100%' }}
            onClick={handleProceed}
            color='secondary'
            disabled={!hasStation || isLoading || isFetching}
          >
            Proceed to Initial Setup
          </Button>
        </Stack>
      </Card>
    </Stack>
  );
};

export default PosISSelection;
